import { useEffect } from 'react';

interface UseBeforeUnloadProps {
  enabled: boolean;
}

const useBeforeUnload = ({ enabled }: UseBeforeUnloadProps) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Cancel the event
      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      e.returnValue = '';
      // Note: Custom messages are not supported by modern browsers for security reasons.
      // The browser will show its own generic warning like "Changes you made may not be saved."
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [enabled]);

  return null;
};

export default useBeforeUnload;
